export class PropertyValidatorUtil {
	public static hasAllProperties<T extends object>(element: T, keys: (keyof T)[]): boolean {
		return keys.every(key => Object.hasOwn(element, key));
	}
}
